import type {MergeConditionWithSubConditionsPayload} from '../page-data/payloads/merge-box'
import {USER_CANNOT_PUSH_SUBCONDITION} from './json-api-helpers'

type AgentMergeVisibility = {
  isOpen: boolean
  isFeatureEnabled: boolean
  isUserFeatureEnabled: boolean
  viewerCanUseCopilotCodingAgent: boolean
  userStateCondition: MergeConditionWithSubConditionsPayload | undefined
  isUserBlockedFromPushing: boolean
  isConfirmingMergeInfo: boolean
  isStacked: boolean
}

function canUserUseAgentMerge(userStateCondition: MergeConditionWithSubConditionsPayload | undefined) {
  return (
    !!userStateCondition &&
    userStateCondition.result !== 'UNKNOWN' &&
    !userStateCondition.failedSubConditions.some(
      subCondition => subCondition.displayName === USER_CANNOT_PUSH_SUBCONDITION,
    )
  )
}

export function shouldShowAgentMerge({
  isOpen,
  isFeatureEnabled,
  isUserFeatureEnabled,
  viewerCanUseCopilotCodingAgent,
  userStateCondition,
  isUserBlockedFromPushing,
  isConfirmingMergeInfo,
  isStacked,
}: AgentMergeVisibility) {
  return (
    isOpen &&
    isFeatureEnabled &&
    isUserFeatureEnabled &&
    // Agent Merge hands the pull request to the Copilot cloud agent, so it can only be
    // offered where that agent is available to this viewer on this repository — the same
    // gate the Conflicts and Checks sections use for their Copilot actions.
    viewerCanUseCopilotCodingAgent &&
    canUserUseAgentMerge(userStateCondition) &&
    !isUserBlockedFromPushing &&
    !isConfirmingMergeInfo &&
    !isStacked
  )
}
